import React, { useContext } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';

const AddOutreachFormLayout = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const showFlag = state?.modalFlags?.showAddOutreachModal;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        const tag = (e.target as HTMLElement).tagName;
        if (e.key === 'Enter' && tag !== 'TEXTAREA' && tag !== 'BUTTON') {
            e.preventDefault();
            state.actions?.SAVE?.(e as any, state, dispatch);
        }
    };

    return (
        <div
            id="add-outreach-log"
            className={`modal fade ${showFlag ? 'show' : ''}`}
            tabIndex={-1}
            role="dialog"
            style={{ display: showFlag ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            onKeyDown={handleKeyDown}>
            <div className="modal-dialog modal-dialog-centered max-800 mx-auto">
                <div className="modal-content">
                    <div className="modal-header p-4 height-70 border-0 bg-gray-f2">
                        <h5 className="modal-title">Add Outreach Log</h5>
                        <button
                            type="button"
                            className="btn-close btn-close-small"
                            onClick={() =>
                                dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showAddOutreachModal' } })
                            }
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body p-4">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddOutreachFormLayout;
